import React from 'react';
import type { FC } from 'react';

interface BrokenThumbnailIconProps {
    className?: string;
}

export const BrokenThumbnailIcon: FC<BrokenThumbnailIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="149"
            height="128"
            viewBox="0 0 149 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Bin Icon</title>
            <path
                d="M117.59 0.0132728C117.099 0.0547213 116.623 0.203416 116.196 0.448867C115.768 0.694319 115.4 1.03054 115.117 1.43382L27.5692 122.654C27.0459 123.38 26.8323 124.283 26.9754 125.166C27.1184 126.049 27.6064 126.84 28.332 127.363C29.0576 127.886 29.9614 128.1 30.8445 127.957C31.7276 127.814 32.5176 127.326 33.0409 126.6L44.1948 111.184H140.158C144.576 111.184 148.158 107.603 148.158 103.184V86.2458L112.802 56.6248L72.8689 90.1918C72.3023 90.6545 71.6006 90.9202 70.8697 90.9486C70.1388 90.9771 69.4184 90.7668 68.8177 90.3496L62.3989 85.9827L66.2922 80.511L70.5013 83.4047L110.645 49.6798C111.15 49.2457 111.773 48.971 112.434 48.8907C112.886 48.8449 113.343 48.8912 113.777 49.0268C114.211 49.1625 114.613 49.3846 114.959 49.6798L148.158 77.5121V24.902C148.158 20.4837 144.576 16.902 140.158 16.902H112.276L120.589 5.37979C120.977 4.85864 121.206 4.23624 121.249 3.58769C121.291 2.93914 121.145 2.29215 120.828 1.72479C120.511 1.15743 120.037 0.693945 119.462 0.390249C118.887 0.0865538 118.237 -0.0443708 117.59 0.0132728ZM8.00001 16.902C3.58173 16.902 0 20.4837 0 24.902V87.8242L36.829 62.9383C37.3876 62.5583 38.0475 62.3552 38.7231 62.3552C39.3986 62.3552 40.0586 62.5583 40.6172 62.9383L55.2962 72.9874L95.7555 16.902H8.00001ZM40.4067 28.6873C46.9155 28.6873 52.192 33.9638 52.192 40.4726C52.192 46.9814 46.9155 52.2579 40.4067 52.2579C33.8979 52.2579 28.6214 46.9814 28.6214 40.4726C28.6214 33.9638 33.8979 28.6873 40.4067 28.6873ZM38.7757 69.778L0 95.9792V103.184C0 107.603 3.58172 111.184 8 111.184H27.6744L51.3502 78.4065L38.7757 69.778Z"
                fill="#323840"
            />
        </svg>
    );
};
